var postLink = function(scope, elem, attrs){
  elem.resizable(JSON.parse(attrs.resizable));
  elem.on('resizestop', function (evt, ui) {
    scope.$apply(function() {
      if (scope.resizeStop) { 
        scope.resizeStop({$evt: evt, $ui: ui }); 
      }                
    });
  });
  elem.on('resize', function (evt, ui) {
    scope.$apply(function() {
      if (scope.onResize) { 
        scope.onResize({$evt: evt, $ui: ui }); 
      }                
    });
  });
};
export default function () {
  return {
    restrict: 'A',
    scope: {
      resizeStop: '&resizeStop',
      onResize: '&onResize'
    },
    link: postLink
  };
}